import DocumentColor from './DocumentColour.svg';
import DocumentDark from './DocumentDark.svg';
import DocumentLight from './DocumentLight.svg';
export const document = { color: DocumentColor, dark: DocumentDark, light: DocumentLight };
//# sourceMappingURL=index.js.map